import { useState, useEffect, useContext } from 'react';
import { getAllTurfs } from '../../services/turf'
import TurfCard from '../../components/turfCard'
import { Grid2 as Grid } from '@mui/material';


const Turfs = ({turfs}) => {
    if (Array.isArray(turfs)) {
        return (<Grid container sx={{padding: 1}} columns={12}>        
            {turfs.map(_turf => <TurfCard key={`turf-${_turf.id}`} turf={_turf}/>)}
        </Grid>)
    }
}

const Home = () => {
    const [turfs, setTurfs] = useState([])
    const getTurfsData = async() => {
        const data = await getAllTurfs()
        setTurfs(data);
    }
    useEffect(()=>{
        getTurfsData()
    }, [])
    return(
        <>
            <Turfs turfs={turfs}/> 
        </>

    )
}

export default Home